import React from 'react';  
import { Button, Col, Row } from "reactstrap";
import classes from './Popup.module.scss';

class Popup extends React.Component {  
  render() {  
return (  
<div className={classes.popup}>  
<div className={classes.inner}>  
<Row>
  <Col xs={{size: 10, offset: 1}}>
  <h1>{this.props.text}</h1> 
  <h1>{this.props.text2}</h1>  
  </Col>
</Row>
<Row>    
  <Col xs={{size: 4, offset: 4}}>
    <Button onClick={this.props.closePopup} color="primary"  size="lg">Got it!</Button>  
  </Col>
</Row>
</div>  
</div>  
);  
}  
}  


export default Popup;